import React, { Component } from 'react'
import Icon from './Icon'
import { i18n } from '../i18n/i18n'

export type ActionName = 'view' |
  'preview' |
  'edit' |
  'delete' |
  'history' |
  'print' |
  'scan' |
  'generate' |
  'resume' |
  'start' |
  'rollback' |
  'download' |
  'accept' |
  'reject' |
  'onboard' |
  'close' |
  'list' |
  'token' |
  'design'

type ActionIcons = Record<ActionName, ActionIcon>

interface ActionIcon {
  name: ActionName
  icon: string,
  label: string
}

interface ActionsProps {
  id: number
  actions: ActionName[]
  additionalInfo?: string
  onClick: (id: number, action: ActionName, additionalInfo?: string) => void
  limitActions?: boolean
}

export default class Actions extends Component<ActionsProps> {
  icons: ActionIcons = {
    view: { name: 'view', icon: 'eye', label: i18n('View') },
    preview: { name: 'preview', icon: 'image', label: i18n('Preview')  },
    edit: { name: 'edit', icon: 'edit', label: i18n('Edit')  },
    delete: { name: 'delete', icon: 'delete-bin-6', label: i18n('Delete')  },
    history: { name: 'history', icon: 'time', label: i18n('History')  },
    print: { name: 'print', icon: 'printer', label: i18n('Print')  },
    scan: { name: 'scan', icon: 'qr-scan-2', label: i18n('Scan')  },
    generate: { name: 'generate', icon: 'download-2', label: i18n('Generate')  },
    resume: { name: 'resume', icon: 'pause-circle', label: i18n('Resume')  },
    start: { name: 'start', icon: 'play-circle', label: i18n('Start')  },
    rollback: { name: 'rollback', icon: 'skip-back', label: i18n('Rollback')  },
    download: { name: 'download', icon: 'download-2', label: i18n('Download')  },
    accept: { name: 'accept', icon: 'checkbox-circle', label: i18n('Accept')  },
    reject: { name: 'reject', icon: 'close-circle', label: i18n('Reject')  },
    onboard: { name: 'onboard', icon: 'add-circle', label: i18n('Onboard')  },
    close: { name: 'close', icon: 'indeterminate-circle', label: i18n('Close')  },
    list: { name: 'list', icon: 'file-list', label: i18n('List')  },
    token: { name: 'token', icon: 'key-2', label: i18n('Token')  },
    design: { name: 'design', icon: 'palette', label: i18n('Design')  }
  }

  get actions () {
    return this.props.actions.map(action => {
      var limit = false
      if(this.props.limitActions){
        limit = this.props.limitActions!
      }

      if(limit == true  && action != "design"){
        return undefined
      }

      

      const icon = this.icons[action]
      const handleClick = () => this.props.onClick(this.props.id, action, this.props.additionalInfo)
      return (
        <div
          className="ml-1"
          key={action}>
          <Icon
            className="hover:text-primary"
            name={icon.icon}
            tooltip={icon.label}
            size="small"
            color="gray"
            onClick={handleClick} />
        </div>
      )
    })
  }

  render () {
    return (
      <div className="flex">
        {this.actions}
      </div>
    )
  }
}
